<template>
  <div>
    <div class="huobu_title">非特殊订单</div>
    <!-- 查询非特殊表单 -->
    <el-form inline :model="form" ref="form">
      <el-row :gutter="24">
        <el-col :md="5">
          <el-form-item prop="orderCode">
            <el-input
              type="text"
              v-model="form.orderCode"
              placeholder="请输入订单编码"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="5">
          <el-form-item prop="productCode">
            <el-input
              type="text"
              v-model="form.productCode"
              placeholder="请输入产品编码"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="5">
          <el-form-item prop="productName">
            <el-input
              type="text"
              v-model="form.productName"
              placeholder="请输入产品名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="5">
          <el-form-item prop="orderStartTime">
            <el-date-picker
              v-model="form.orderStartTime"
              type="datetime"
              placeholder="请选择订单开始时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :md="5">
          <el-form-item prop="orderEndTime">
            <el-date-picker
              v-model="form.orderEndTime"
              type="datetime"
              placeholder="请选择订单结束时间"
              default-time="23:59:59"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :md="14" style="text-align: right">
          <el-button
            type="primary"
            @click="search"
            size="small"
            icon="el-icon-search"
            >查询</el-button
          >
          <el-button @click="reset('form')" size="small" icon="el-icon-refresh"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-form>
    <el-button class="md20" @click="add">设置为特殊订单</el-button>
    <!-- 非特殊订单表格 -->
    <vxe-table
      class="md20"
      ref="xCheckTable"
      row-id="id"
      @checkbox-all="({ records }) => selectAllEvent({ records })"
      @checkbox-change="({ records }) => selectChangeEvent({ records })"
      :edit-config="{ trigger: 'click', mode: 'cell' }"
      :data="tableData"
    >
      <vxe-table-column type="checkbox" width="50"></vxe-table-column>
      <vxe-table-column field="orderCode" title="订单编码"></vxe-table-column>
      <vxe-table-column
        field="orderTypeName"
        title="订单类型"
      ></vxe-table-column>
      <vxe-table-column
        field="productCode"
        title="产品编码"
      ></vxe-table-column>
      <vxe-table-column
        field="productName"
        title="产品名称"
      ></vxe-table-column>
      <vxe-table-column
        field="responseBranchName"
        title="分公司"
      ></vxe-table-column>
      <vxe-table-column
        field="createDateAll"
        title="订单时间"
      ></vxe-table-column>
      <vxe-table-column
        field="businessTypeName"
        title="业务类型"
      ></vxe-table-column>
      <vxe-table-column field="companyName" title="公司主体"></vxe-table-column>
      <vxe-table-column field="responseName" title="负责人"></vxe-table-column>
    </vxe-table>
    <div class="page-pageination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="tablePage.currentPage"
        :page-sizes="[5, 10, 15, 20, 50, 100, 150, 200]"
        :page-size="tablePage.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tablePage.totalResult"
      >
      </el-pagination>
    </div>
    <div class="huobu_title yibuhuo_title">特殊订单</div>
    <!-- 查询特殊表单 -->
    <el-form inline :model="formBusiness" ref="formBusiness">
      <el-row :gutter="24">
        <el-col :md="5">
          <el-form-item prop="orderCode">
            <el-input
              type="text"
              v-model="formBusiness.orderCode"
              placeholder="请输入订单编码"
            ></el-input>
          </el-form-item>
        </el-col>
         <el-col :md="5">
          <el-form-item prop="productCode">
            <el-input
              type="text"
              v-model="formBusiness.productCode"
              placeholder="请输入产品编码"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="5">
          <el-form-item prop="productName">
            <el-input
              type="text"
              v-model="formBusiness.productName"
              placeholder="请输入产品名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="5">
          <el-form-item prop="orderStartTime">
            <el-date-picker
              v-model="formBusiness.orderStartTime"
              type="datetime"
              placeholder="请选择订单开始时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :md="5">
          <el-form-item prop="orderEndTime">
            <el-date-picker
              v-model="formBusiness.orderEndTime"
              type="datetime"
              placeholder="请选择订单结束时间"
              default-time="23:59:59"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :md="14" style="text-align: right">
          <el-button
            type="primary"
            @click="searchBusiness"
            size="small"
            icon="el-icon-search"
            >查询</el-button
          >
          <el-button
            @click="resetBusiness('formBusiness')"
            size="small"
            icon="el-icon-refresh"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-form>
    <el-button class="md20" @click="tableDel">取消特殊订单</el-button>
    <el-button class="md20" @click="tableAdd">生成奖励池余额</el-button>
    <!-- 特殊订单表格 -->
    <vxe-table
      class="md20"
      ref="xCheckTable"
      row-id="id"
      @checkbox-all="({ records }) => selectAllEventBusiness({ records })"
      @checkbox-change="({ records }) => selectChangeEventBusiness({ records })"
      :edit-config="{ trigger: 'click', mode: 'cell' }"
      :data="checkTableData"
    >
      <vxe-table-column type="checkbox" width="50"></vxe-table-column>
      <vxe-table-column field="orderCode" title="订单编码"></vxe-table-column>
      <vxe-table-column
        field="orderTypeName"
        title="订单类型"
      ></vxe-table-column>
      <vxe-table-column
        field="productCode"
        title="产品编码"
      ></vxe-table-column>
      <vxe-table-column
        field="productName"
        title="产品名称"
      ></vxe-table-column>
      <vxe-table-column
        field="responseBranchName"
        title="分公司"
      ></vxe-table-column>
      <vxe-table-column
        field="createDateAll"
        title="订单时间"
      ></vxe-table-column>
      <vxe-table-column
        field="businessTypeName"
        title="业务类型"
      ></vxe-table-column>
      <vxe-table-column field="companyName" title="公司主体"></vxe-table-column>
      <vxe-table-column field="responseName" title="负责人"></vxe-table-column>
    </vxe-table>
    <div class="page-pageination">
      <el-pagination
        @size-change="handleSizeChangeBusiness"
        @current-change="handleCurrentChangeBusiness"
        :current-page="tablePageBusiness.currentPage"
        :page-sizes="[5, 10, 15, 20, 50, 100, 150, 200]"
        :page-size="tablePageBusiness.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tablePageBusiness.totalResult"
      >
      </el-pagination>
    </div>
    <Modal :modalConfig="modalConfig" ref="modalForm" @onClose="closeModal">
      <vxe-table ref="xTable" :data="ruleList">
        <vxe-table-column min-width="100" field="productName" title="产品">
        </vxe-table-column>
        <vxe-table-column min-width="100" field="scanType" title="奖励动作">
          <template #default="{ row }">
            <el-select
              v-model="row.scanType"
              placeholder="请选择奖励动作"
              disabled
            >
              <el-option
                v-for="item in rewardAction"
                :key="item.dictCode"
                :label="item.dictValue"
                :value="item.dictCode"
              >
              </el-option>
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column min-width="100" field="beneficiary" title="奖励对象">
          <template #default="{ row }">
            <el-select
              v-model="row.beneficiary"
              placeholder="请选择奖励对象"
              disabled
            >
              <el-option
                v-for="item in rewardObject"
                :key="item.dictCode"
                :label="item.dictValue"
                :value="item.dictCode"
              >
              </el-option>
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column min-width="100" field="awardMoney" title="奖励金额">
          <template #default="{ row }">
            <el-input-number
              v-model="row.awardMoney"
              label="奖励金额"
              :step="0.0001"
              :precision="4"
            ></el-input-number>
          </template>
        </vxe-table-column>
        <vxe-table-column fixed="right" title="操作" align="center" width="80">
          <template #default="{ rowIndex }">
            <el-button
              class="text-red"
              slot="reference"
              type="text"
              icon="el-icon-delete"
              @click="deleteRule(rowIndex)"
            ></el-button>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="dialog-footer">
        <el-button
          type="primary"
          @click="submit"
          size="small"
          icon="el-icon-check"
          >提交</el-button
        >
        <el-button
          type="danger"
          @click="closeModal"
          size="small"
          icon="el-icon-close"
          >关闭</el-button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
import request from '@/found/utils/request';
import Modal from '@/found/components/modal/components/full.vue';
import { Loading } from 'element-ui';

export default {
  components: {
    Modal,
  },
  props: {
    formConfig: Object,
  },
  data() {
    return {
      tableData: [],
      checkTableData: [],
      selectionList: [],
      selectionListBusiness: [],
      form: {
        orderCode: '',
        productCode: '',
        productName: '',
        orderStartTime: '',
        orderEndTime: '',
      },
      formBusiness: {
        orderCode: '',
        productCode: '',
        productName: '',
        orderStartTime: '',
        orderEndTime: '',
      },
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
      tablePageBusiness: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
      modalConfig: {
        title: '奖励池生成',
        visible: false,
      },
      ruleList: [],
      rewardAction: [], // 奖励动作
      rewardObject: [], // 奖励对象
    };
  },
  created() {
    console.log(this.formConfig);
    this.getTableList();
    this.getBusinessTableList();
    this.getDictSelect();
  },
  methods: {
    // 删除规则
    deleteRule(index) {
      this.ruleList.splice(index, 1);
    },
    // 获取数据字典
    getDictSelect() {
      const params = ['reward_action', 'tpm_reward_object'];
      request.post('/mdm/mdmdictdata/batchDictSelect', params).then((res) => {
        if (res.success) {
          this.rewardAction = res.result.reward_action;
          this.rewardObject = res.result.tpm_reward_object;
        }
      });
    },
    tableAdd() {
      if (this.selectionListBusiness.length === 0) {
        this.$message.error('请先选择特殊订单数据');
        return;
      }
      const orderCodes = [];
      this.selectionListBusiness.forEach((v) => {
        orderCodes.push(v.orderCode);
      });
      const data = {
        orderCodes,
      };
      const loadingInstance = Loading.service({
        fullscreen: true,
        text: '加载中...',
        background: 'rgba(0, 0, 0, 0.8)',
      });
      request
        .post('/dms/dmsspecialawardrule/getProductByOrderCodes', data)
        .then((res) => {
          if (res.success) {
            this.$nextTick(() => {
              loadingInstance.close();
            });
            if (res.result && res.result.length >= 1) {
              this.ruleList = res.result;
              this.modalConfig.visible = true;
            } else {
              this.$message({
                type: 'success',
                message: '奖励池生成成功',
              });
            }
          } else {
            this.$nextTick(() => {
              loadingInstance.close();
            });
          }
        })
        .catch((err) => {
          this.$nextTick(() => {
            loadingInstance.close();
          });
        });
    },
    submit() {
      request
        .post('/dms/dmsspecialawardrule/saveList', this.ruleList)
        .then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.modalConfig.visible = false;
          }
        });
    },
    // 关闭弹窗
    closeModal() {
      this.modalConfig.visible = false;
    },
    // 获取非特殊列表
    getTableList() {
      const data = {
        custCode: this.formConfig.row.customerCode,
        pageSize: this.tablePage.pageSize,
        pageNum: this.tablePage.currentPage,
        ...this.form,
      };
      request
        .post('/dms/dms/order/querySpecialOrderByCustCode', data)
        .then((res) => {
          if (res.success) {
            this.tableData = res.result.data;
            this.tablePage.totalResult = res.result.count;
          }
        });
    },
    // 获取特殊列表
    getBusinessTableList() {
      const data = {
        custCode: this.formConfig.row.customerCode,
        pageSize: this.tablePageBusiness.pageSize,
        pageNum: this.tablePageBusiness.currentPage,
        ...this.formBusiness,
      };
      request.post('/dms/dmstransitorderspecial/list', data).then((res) => {
        if (res.success) {
          this.checkTableData = res.result.data;
          this.tablePageBusiness.totalResult = res.result.count;
        }
      });
    },
    // 设置为特殊列表
    add() {
      if (this.selectionList.length === 0) {
        this.$message.error('请先选择非特殊订单数据');
        return;
      }
      // const orderCodes = this.selectionList.map((v) => v.orderCode);
      // const data = {
      //   custCode: this.formConfig.row.customerCode,
      //   custName: this.formConfig.row.customerName,
      //   orderCodes,
      // };
      const data = this.selectionList.map((e) => ({
        custCode: this.formConfig.row.customerCode,
        custName: this.formConfig.row.customerName,
        orderCode: e.orderCode,
        orderDetailCode: e.orderDetailCode,
        productCode: e.productCode,
        productName: e.productName,
      }));
      request.post('/dms/dmstransitorderspecial/save', data).then((res) => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: '操作成功',
          });
          this.tablePage.currentPage = 1;
          this.tablePageBusiness.currentPage = 1;
          this.getTableList();
          this.getBusinessTableList();
        }
      });
    },
    // 取消特殊列表
    tableDel() {
      if (this.selectionListBusiness.length === 0) {
        this.$message.error('请先选择特殊订单数据');
        return;
      }
      const ids = this.selectionListBusiness.map((v) => v.id);
      const data = {
        custCode: this.formConfig.row.customerCode,
        ids,
      };
      request.post('/dms/dmstransitorderspecial/delete', data).then((res) => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: '操作成功',
          });
          this.tablePage.currentPage = 1;
          this.tablePageBusiness.currentPage = 1;
          this.getTableList();
          this.getBusinessTableList();
        }
      });
    },
    /** @desc 非特殊pageSize改变 */
    handleSizeChange(val) {
      this.tablePage.pageSize = val;
      this.getTableList();
    },
    /** @desc 非特殊currentPage改变 */
    handleCurrentChange(val) {
      this.tablePage.currentPage = val;
      this.getTableList();
    },
    /** @desc 特殊pageSize改变 */
    handleSizeChangeBusiness(val) {
      this.tablePageBusiness.pageSize = val;
      this.getBusinessTableList();
    },
    /** @desc 特殊currentPage改变 */
    handleCurrentChangeBusiness(val) {
      this.tablePageBusiness.currentPage = val;
      this.getBusinessTableList();
    },
    // 非特殊全选
    selectAllEvent({ records }) {
      this.selectionList = records;
    },
    // 非特殊选择
    selectChangeEvent({ records }) {
      this.selectionList = records;
    },
    // 特殊全选
    selectAllEventBusiness({ records }) {
      this.selectionListBusiness = records;
    },
    // 特殊选择
    selectChangeEventBusiness({ records }) {
      this.selectionListBusiness = records;
    },
    // 非特殊搜索
    search() {
      this.tablePage.currentPage = 1;
      this.getTableList();
    },
    // 非特殊重置
    reset(formName) {
      this.tablePage.currentPage = 1;
      this.$refs[formName].resetFields();
      this.getTableList();
    },
    // 特殊搜索
    searchBusiness() {
      this.tablePageBusiness.currentPage = 1;
      this.getBusinessTableList();
    },
    // 特殊重置
    resetBusiness(formName) {
      this.tablePageBusiness.currentPage = 1;
      this.$refs[formName].resetFields();
      this.getBusinessTableList();
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-form-item,
/deep/ .el-form-item__content {
  width: 100%;
}
.huobu_title {
  font-size: 16px;
  color: #333;
  padding-bottom: 20px;
}
.md20 {
  margin-bottom: 20px;
}
.yibuhuo_title {
  padding-top: 20px;
  margin-top: 20px;
}
.pd20 {
  padding-bottom: 20px;
}
/deep/ .page-pageination {
  text-align: right;
  padding: 10px 0;
  .el-input {
    display: inline-block !important;
  }
}
</style>
